import article from '../api/article';
import page from '../api/page';

const state = () => ({
  curentArticle:{
    title:"",
    msgbody:"",
    tagname:[],
    typeID:0,
    groupinfoID:0
  },
})
// getters
const getters = {

}

// actions
const actions = {
  async InitArticaleData({commit},pramas){
    if(pramas.action==='add'){
      commit('initArticaleData',pramas)
    }
    if(pramas.action==='edit'){
      // get data from api
      const res =""
      // commit rewrite
      commit('RewriteAritcle',res)
    }
  },
  async AddArticle({commit},pramas){
    const res = await article.article_add(pramas);
    return res
  },
  async UpdateArticle({commit},pramas){
    const res = await article.article_update(pramas);
    return res
  }
}

// mutations
const mutations = {
  initArticaleData(state,res){
    state.curentArticle.groupinfoID = res.groupinfoID;
    state.curentArticle.typeID = res.typeID;
  },
  RewriteAritcle(state,res){
    state.curentArticle = res
  },
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}